import map from "../data/tilemap.json";

const DEFAULT_NAME = "cat";

export const getEnemyNames = () =>
  map.layers
    .filter((layer) => layer.type === "objectgroup")
    .map((layer) => layer.objects?.find((f) => f.type === "enemy"))
    .map((g) => g?.name ?? DEFAULT_NAME);
